import { getParam } from '~/js/helpers/url-helper'
const ID_FF_ZVList = 'js-ZVList'
const ID_ZETA_ZVList = 'ZVList'

const ID_PRODUCT_REVIEW = 'js-product-review'

document.addEventListener('DOMContentLoaded', () => {
  const elementProductReview = document.getElementById(ID_PRODUCT_REVIEW)
  if (!elementProductReview) return

  const elementZVList = document.getElementById(ID_FF_ZVList)
  if (!elementZVList) return

  const slug = getParam('slug')
  if (!slug) return
  elementZVList.dataset.questionnaireSlug = slug
  elementZVList.id = ID_ZETA_ZVList
})
